import { render, staticRenderFns } from "./logistics.vue?vue&type=template&id=38ce4822&scoped=true"
import script from "./logistics.vue?vue&type=script&lang=js"
export * from "./logistics.vue?vue&type=script&lang=js"
import style0 from "./logistics.vue?vue&type=style&index=0&id=38ce4822&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ce4822",
  null
  
)

export default component.exports